import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useAnalysisTypes } from "@services/servicesGenericsTables";
import React from "react";

const PartesEficienciaForm = () => {
  const { analysisTypeList } = useAnalysisTypes();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          name="analisis"
          options={analysisTypeList}
          label="Análisis"
          getOptionLabel={(option) => option.descripcion}
          validation={{ required: "El analysis es requerida" }}
        />
        <MTextField
          key={"parte"}
          name={"parte"}
          label={"Parte"}
          type="text"
          fullWidth
          validation={{ required: `El campo parte es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PartesEficienciaForm;
